import { render, staticRenderFns } from "./ChangeNameAndImage.vue?vue&type=template&id=6a4dea40&scoped=true&"
import script from "./ChangeNameAndImage.vue?vue&type=script&lang=js&"
export * from "./ChangeNameAndImage.vue?vue&type=script&lang=js&"
import style0 from "./ChangeNameAndImage.vue?vue&type=style&index=0&id=6a4dea40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a4dea40",
  null
  
)

export default component.exports